export default {

    highlightColorPresets() {
        return [
            '#FFCCBC',
            '#FFE0B2',
            '#FFF59D',
            '#C8E6C9',
            '#B2EBF2',
            '#B3E5FC',
            '#BBDEFB',
            '#D1C4E9',
            '#F8BBD0',
        ];
    },

}
